import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import LandingPage from './LandingPage';
import { GoogleOAuthProvider } from "@react-oauth/google";

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId="761753459315-sgfuo0go9f1j21se7n18m7fiq75p3b09.apps.googleusercontent.com">
      <LandingPage />
    </GoogleOAuthProvider>
  </React.StrictMode>
);

reportWebVitals();